import { render, staticRenderFns } from "./Profile.Dashboard.vue?vue&type=template&id=59d8303a&scoped=true"
import script from "./Profile.Dashboard.vue?vue&type=script&lang=js"
export * from "./Profile.Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Profile.Dashboard.vue?vue&type=style&index=0&id=59d8303a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d8303a",
  null
  
)

export default component.exports